import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { Control, FieldErrors } from 'react-hook-form';
import { CreateSearchFormData } from '../CreateSearchSchema';
import styles from './providersStep.module.scss';
import { SearchFilterEntity, SEARCH_FILTER_KEYS } from 'v2/models';
import InputTags from 'v2/form/InputTags/InputTags';

interface ExcludeProvidersStepProps {
  filters: SearchFilterEntity[];
  errors: FieldErrors<CreateSearchFormData>;
  control: Control<CreateSearchFormData>;
}

const ExcludeProvidersFilter = ({
  filters,
  control,
  errors,
}: ExcludeProvidersStepProps) => {
  const filter = filters.filter(
    (filter) => filter.key === SEARCH_FILTER_KEYS.exclude_providers
  )[0];
  const error = getError(errors, filter);

  return (
    <div className="mt-5" data-cy="exclude-data-providers-container">
      <span className={styles.textForm}>Exclude Providers</span>
      <FormGroup className={styles.inputForm}>
        <InputTags
          label={
            "Enter a provider's name below and press enter to exclude it from this request"
          }
          name={`filters.${filter.key}`}
          control={control}
          error={error}
          tooltip="Type a provider and press return to capture it."
        />
      </FormGroup>
    </div>
  );
};

export default ExcludeProvidersFilter;

export function getError(
  errors: FieldErrors<CreateSearchFormData>,
  filter: SearchFilterEntity
): string {
  const error = errors?.filters?.[`${filter.key}`];

  if (typeof error === 'string') {
    return error;
  }
  let erroMsg = '';
  if (typeof error === 'object') {
    const filterErr = error as FieldErrors<CreateSearchFormData>['filters'];
    if (!filterErr) {
      return erroMsg;
    }
    if ('value' in filterErr) {
      erroMsg = 'Please enter a valid value.';
    }
    if ('unit' in filterErr) {
      erroMsg += ' Please enter a valid Unit.';
    }
  }
  return erroMsg.trim();
}
